import React, { useMemo, useState } from "react";
import {
  Container,
  Row,
  Card,
  Col,
  Modal,
  Form,
  Button,
  Offcanvas,
  Badge,
} from "react-bootstrap";
import DataTable from "react-data-table-component";
import Breadcrumb from "Common/BreadCrumb";
import { Link, useLocation } from "react-router-dom";
import Select from "react-select";
import {
  useAddClasseMutation,
  useDeleteClasseMutation,
  useFetchClassesQuery,
} from "features/classes/classeSlice";
import Swal from "sweetalert2";
import ModalEdit from "./ModalEdit";
import { useGetNiveauxQuery } from "features/niveaux/niveauxSlice";
import {
  useFetchEtudiantsByClasseIdMutation,
  useUpdateEleveClasseMutation,
} from "features/etudiants/etudiantSlice";

const Classes = () => {
  const { data = [] } = useFetchClassesQuery();
  const { data: AllNiveaux = [] } = useGetNiveauxQuery();

  const handleReload = async () => {
    window.location.reload();
  };

  const [deleteClasse] = useDeleteClasseMutation();

  const [showClasse, setShowClasse] = useState<boolean>(false);

  const notifySuccess = () => {
    Swal.fire({
      position: "center",
      icon: "success",
      title: "La classe a été créée avec succès",
      showConfirmButton: false,
      timer: 2500,
    });
  };

  const notifyError = (err: any) => {
    Swal.fire({
      position: "center",
      icon: "error",
      title: `Une erreur est survenue: ${err}`,
      showConfirmButton: false,
      timer: 2500,
    });
  };

  const swalWithBootstrapButtons = Swal.mixin({
    customClass: {
      confirmButton: "btn btn-success",
      cancelButton: "btn btn-danger",
    },
    buttonsStyling: false,
  });

  const AlertDelete = async (_id: any) => {
    swalWithBootstrapButtons
      .fire({
        title: "Etes-vous sûr?",
        text: "Vous ne pouvez pas revenir en arrière?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Oui, supprime-le !",
        cancelButtonText: "Non, annuler !",
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          deleteClasse(_id);
          swalWithBootstrapButtons.fire(
            "Supprimé !",
            "La classe est supprimée.",
            "success"
          );
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          swalWithBootstrapButtons.fire(
            "Annulé",
            "La classe est en sécurité :)",
            "info"
          );
        }
      });
  };

  const [modal_AddClasse, setmodal_AddClasse] = useState<boolean>(false);
  function tog_AddClasse() {
    setmodal_AddClasse(!modal_AddClasse);
  }
  const [modal_UpdateClasse, setmodal_UpdateClasse] = useState<boolean>(false);
  function tog_UpdateClasse() {
    setmodal_UpdateClasse(!modal_UpdateClasse);
  }

  const [selectedNiveau, setSelectedNiveau] = useState<string>("");

  const handleSelectNiveau = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const value = event.target.value;
    setSelectedNiveau(value);
  };

  const [createClasse] = useAddClasseMutation();

  const initialClasse = {
    nom_classe: "",
    niveau: "",
  };

  const [classe, setClasse] = useState(initialClasse);

  const { nom_classe, niveau } = classe;

  const onChangeClasse = (e: React.ChangeEvent<HTMLInputElement>) => {
    setClasse((prevState) => ({
      ...prevState,
      [e.target.id]: e.target.value,
    }));
  };

  const onSubmitClasse = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    try {
      classe["niveau"] = selectedNiveau;
      createClasse(classe).then(() => notifySuccess());
    } catch (error) {
      notifyError(error);
    }
  };

  const classLocation = useLocation();

  const [students, setStudents] = useState<any[]>([]);

  const [fetchEtudiantsByClasseId, { data: fetchedEtudiants }] =
    useFetchEtudiantsByClasseIdMutation();

  const handleListOfStudents = async (selectedOption: any) => {
    const result = await fetchEtudiantsByClasseId(selectedOption._id!).unwrap();
    setStudents(result);
    setShowClasse(!showClasse);
  };

  const [deleteEleveFromClasse] = useUpdateEleveClasseMutation();

  const AlertDeleteEleveFromClasse = async (_id: any) => {
    swalWithBootstrapButtons
      .fire({
        title: "Etes-vous sûr?",
        text: "Vous ne pouvez pas revenir en arrière?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Oui, supprime-le !",
        cancelButtonText: "Non, annuler !",
        reverseButtons: true,
      })
      .then(async (result) => {
        if (result.isConfirmed) {
          deleteEleveFromClasse({
            _id,
            classe: null,
          });
          await handleReload();
          swalWithBootstrapButtons.fire(
            "Supprimé !",
            "L'élève est supprimée de ce classe.",
            "success"
          );
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          swalWithBootstrapButtons.fire(
            "Annulé",
            "L'élève est en sécurité :)",
            "info"
          );
        }
      });
  };

  // Filters
  const [filterNiveau, setFilterNiveau] = useState<string>("");
  const [searchTerm, setSearchTerm] = useState("");
  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(event.target.value);
  };

  // Stats
  const stats = useMemo(() => {
    const niveaux = new Set(data.map((c: any) => c?.niveau?.nom_niveau)).size;
    return { total: data.length, niveaux };
  }, [data]);

  const getFilteredClasses = () => {
    let filteredClasses = [...data];

    if (filterNiveau) {
      filteredClasses = filteredClasses.filter(
        (classe: any) => classe?.niveau?.nom_niveau === filterNiveau
      );
    }

    if (searchTerm) {
      const term = searchTerm.toLowerCase();
      filteredClasses = filteredClasses.filter(
        (classe: any) =>
          classe?.nom_classe?.toLowerCase().includes(term) ||
          classe?.niveau?.nom_niveau?.toLowerCase().includes(term)
      );
    }

    return filteredClasses;
  };

  const columns = [
    {
      name: <span className="fw-semibold fs-13">Niveau</span>,
      selector: (row: any) => row?.niveau?.nom_niveau!,
      cell: (row: any) => (
        <Badge bg="info-subtle" text={"info" as any} className="fs-12 px-2 py-1">
          <i className="ri-graduation-cap-line me-1" />
          {row?.niveau?.nom_niveau}
        </Badge>
      ),
      sortable: true,
    },
    {
      name: <span className="fw-semibold fs-13">Classe</span>,
      selector: (row: any) => row.nom_classe,
      cell: (row: any) => (
        <div className="d-flex align-items-center gap-2">
          <div className="avatar-xs flex-shrink-0">
            <div className="avatar-title bg-primary-subtle text-primary rounded-circle fs-16">
              <i className="ri-door-open-line" />
            </div>
          </div>
          <span className="fw-medium fs-13">{row.nom_classe}</span>
        </div>
      ),
      sortable: true,
    },
    {
      name: <span className="fw-semibold fs-13">Actions</span>,
      cell: (row: any) => (
        <div className="d-flex gap-1">
          <button
            className="btn btn-soft-info btn-sm btn-icon"
            onClick={() => handleListOfStudents(row)}
            title="Voir élèves"
          >
            <i className="ri-eye-line" />
          </button>
          <Link
            to="#"
            state={row}
            className="btn btn-soft-success btn-sm btn-icon"
            onClick={() => tog_UpdateClasse()}
            title="Modifier"
          >
            <i className="ri-edit-2-line" />
          </Link>
          <button
            className="btn btn-soft-danger btn-sm btn-icon"
            onClick={() => AlertDelete(row._id)}
            title="Supprimer"
          >
            <i className="ri-delete-bin-2-line" />
          </button>
        </div>
      ),
    },
  ];

  const columnEtudiants = [
    {
      name: <span className="fw-semibold fs-13">Nom</span>,
      selector: (row: any) => row.nom,
      cell: (row: any) => (
        <div className="d-flex align-items-center gap-2">
          <div className="avatar-xs flex-shrink-0">
            <div className="avatar-title bg-primary-subtle text-primary rounded-circle">
              {row.prenom?.[0]}{row.nom?.[0]}
            </div>
          </div>
          <span className="fw-medium fs-13">{row.prenom} {row.nom}</span>
        </div>
      ),
      sortable: true,
      grow: 2,
    },
    {
      name: <span className="fw-semibold fs-13">Date de Naissance</span>,
      selector: (row: any) => row.date_de_naissance,
      cell: (row: any) => (
        <span className="text-muted fs-13">
          <i className="ri-calendar-line me-1 text-primary" />
          {row.date_de_naissance}
        </span>
      ),
      sortable: true,
    },
    {
      name: <span className="fw-semibold fs-13">Parent</span>,
      selector: (row: any) => row?.parent?.nom_parent || "",
      cell: (row: any) => (
        <span className="fs-13">
          {row?.parent?.nom_parent!} {row?.parent?.prenom_parent!}
        </span>
      ),
      sortable: true,
    },
    {
      name: <span className="fw-semibold fs-13">Actions</span>,
      cell: (row: any) => (
        <div className="d-flex gap-1">
          <Link
            to="/détails-etudiant"
            state={row}
            className="btn btn-soft-info btn-sm btn-icon"
            title="Voir détails"
          >
            <i className="ri-eye-line" />
          </Link>
          <Link
            to="/modifier-etudiant"
            state={row}
            className="btn btn-soft-success btn-sm btn-icon"
            title="Modifier"
          >
            <i className="ri-edit-2-line" />
          </Link>
          <button
            className="btn btn-soft-danger btn-sm btn-icon"
            onClick={() => AlertDeleteEleveFromClasse(row._id)}
            title="Retirer de la classe"
          >
            <i className="ri-delete-bin-2-line" />
          </button>
        </div>
      ),
    },
  ];

  const customStyles = {
    headCells: {
      style: {
        backgroundColor: "#f3f6f9",
        fontWeight: "600",
        fontSize: "13px",
        color: "#495057",
        borderBottom: "2px solid #e9ebec",
      },
    },
    rows: {
      style: {
        fontSize: "13px",
        "&:hover": {
          backgroundColor: "#f3f6f9",
        },
      },
    },
    pagination: {
      style: {
        borderTop: "1px solid #e9ebec",
      },
    },
  };

  // Unique niveaux for filter
  const uniqueNiveaux = useMemo(() => {
    const set = new Set<string>();
    data.forEach((c: any) => {
      if (c?.niveau?.nom_niveau) set.add(c.niveau.nom_niveau);
    });
    return Array.from(set).sort((a, b) => a.localeCompare(b, "fr"));
  }, [data]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb title="Classes" pageTitle="Tableau de bord" />

          {/* KPI Cards */}
          <Row className="mb-3">
            <Col sm={6} xl={3}>
              <Card className="card-animate border-0 shadow-sm cursor-pointer" onClick={() => setFilterNiveau("")}>
                <Card.Body>
                  <div className="d-flex align-items-center">
                    <div className="avatar-sm flex-shrink-0">
                      <span className="avatar-title bg-primary-subtle text-primary rounded-circle fs-3">
                        <i className="ri-door-open-line" />
                      </span>
                    </div>
                    <div className="flex-grow-1 ms-3">
                      <p className="text-uppercase fw-medium text-muted mb-1 fs-13">Total Classes</p>
                      <h4 className="mb-0">{stats.total}</h4>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
            <Col sm={6} xl={3}>
              <Card className="card-animate border-0 shadow-sm">
                <Card.Body>
                  <div className="d-flex align-items-center">
                    <div className="avatar-sm flex-shrink-0">
                      <span className="avatar-title bg-success-subtle text-success rounded-circle fs-3">
                        <i className="ri-graduation-cap-line" />
                      </span>
                    </div>
                    <div className="flex-grow-1 ms-3">
                      <p className="text-uppercase fw-medium text-muted mb-1 fs-13">Niveaux</p>
                      <h4 className="mb-0 text-success">{stats.niveaux}</h4>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {/* Data Table */}
          <Col lg={12}>
            <Card className="border-0 shadow-sm">
              <Card.Header className="border-bottom-dashed bg-white">
                <Row className="g-3 align-items-center">
                  <Col lg={4} md={6}>
                    <div className="search-box">
                      <input
                        type="text"
                        className="form-control search"
                        placeholder="Rechercher par nom de classe, niveau..."
                        value={searchTerm}
                        onChange={handleSearchChange}
                      />
                      <i className="ri-search-line search-icon"></i>
                    </div>
                  </Col>
                  <Col lg={3} md={3}>
                    <select
                      className="form-select"
                      value={filterNiveau}
                      onChange={(e) => setFilterNiveau(e.target.value)}
                    >
                      <option value="">Tous les niveaux</option>
                      {uniqueNiveaux.map((n) => (
                        <option value={n} key={n}>{n}</option>
                      ))}
                    </select>
                  </Col>
                  <Col lg={5} md={3} className="d-flex justify-content-end gap-2">
                    {(filterNiveau || searchTerm) && (
                      <Button
                        variant="soft-secondary"
                        size="sm"
                        onClick={() => { setFilterNiveau(""); setSearchTerm(""); }}
                      >
                        <i className="ri-filter-off-line me-1" />
                        Réinitialiser
                      </Button>
                    )}
                    <Button
                      variant="primary"
                      onClick={() => tog_AddClasse()}
                      className="d-flex align-items-center gap-1"
                    >
                      <i className="ri-add-line fs-16" />
                      Nouvelle classe
                    </Button>
                  </Col>
                </Row>
              </Card.Header>
              <Card.Body className="p-0">
                <DataTable
                  columns={columns}
                  data={getFilteredClasses()}
                  pagination
                  paginationPerPage={15}
                  paginationRowsPerPageOptions={[10, 15, 25, 50]}
                  customStyles={customStyles}
                  noDataComponent={
                    <div className="text-center py-5">
                      <i className="ri-door-open-line fs-1 text-muted d-block mb-2" />
                      <p className="text-muted mb-0">Aucune classe trouvée</p>
                    </div>
                  }
                  paginationComponentOptions={{
                    rowsPerPageText: "Lignes par page",
                    rangeSeparatorText: "sur",
                  }}
                  highlightOnHover
                  responsive
                />
              </Card.Body>
            </Card>
          </Col>

          {/* Add Modal */}
          <Modal
            className="fade"
            show={modal_AddClasse}
            onHide={() => tog_AddClasse()}
            centered
          >
            <Modal.Header closeButton className="bg-primary-subtle">
              <h5 className="modal-title">
                <i className="ri-add-circle-line me-2" />
                Nouvelle classe
              </h5>
            </Modal.Header>
            <Modal.Body>
              <Form className="create-form" onSubmit={onSubmitClasse}>
                <Row className="g-3">
                  <Col md={12}>
                    <Form.Label htmlFor="niveau">Niveau</Form.Label>
                    <Select
                      options={[...AllNiveaux].sort((a: any, b: any) => (a.nom_niveau || "").localeCompare(b.nom_niveau || "", "fr")).map((niveau: any) => ({
                        value: niveau._id,
                        label: niveau.nom_niveau,
                      }))}
                      onChange={(opt: any) => { const e = { target: { value: opt?.value || "" } } as any; handleSelectNiveau(e); }}
                      placeholder="Rechercher un niveau..."
                      isClearable
                      isSearchable
                      noOptionsMessage={() => "Aucun niveau trouvé"}
                    />
                  </Col>
                  <Col md={12}>
                    <Form.Label htmlFor="nom_classe">Nom de la classe</Form.Label>
                    <Form.Control
                      type="text"
                      id="nom_classe"
                      name="nom_classe"
                      onChange={onChangeClasse}
                      value={classe.nom_classe}
                      placeholder="Ex: 1ère A, 2ème B..."
                    />
                  </Col>
                </Row>
                <div className="hstack gap-2 justify-content-end mt-4">
                  <Button
                    variant="light"
                    onClick={() => {
                      tog_AddClasse();
                      setClasse(initialClasse);
                    }}
                  >
                    Annuler
                  </Button>
                  <Button
                    onClick={() => tog_AddClasse()}
                    type="submit"
                    variant="primary"
                  >
                    <i className="ri-check-line me-1" />
                    Enregistrer
                  </Button>
                </div>
              </Form>
            </Modal.Body>
          </Modal>

          {/* Update Modal */}
          <Modal
            className="fade"
            show={modal_UpdateClasse}
            onHide={() => tog_UpdateClasse()}
            centered
          >
            <Modal.Header closeButton className="bg-success-subtle">
              <h5 className="modal-title">
                <i className="ri-edit-2-line me-2" />
                Modifier classe
              </h5>
            </Modal.Header>
            <Modal.Body>
              <ModalEdit
                modal_UpdateClasse={modal_UpdateClasse}
                setmodal_UpdateClasse={setmodal_UpdateClasse}
              />
            </Modal.Body>
          </Modal>

          {/* Students Offcanvas */}
          <Offcanvas
            show={showClasse}
            onHide={() => setShowClasse(!showClasse)}
            placement="end"
            style={{ width: "50%" }}
          >
            <Offcanvas.Header closeButton className="border-bottom bg-light">
              <Offcanvas.Title className="d-flex align-items-center gap-2">
                <i className="ri-group-line text-primary fs-20" />
                Liste des élèves
              </Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
              <DataTable
                columns={columnEtudiants}
                data={students}
                pagination
                paginationPerPage={15}
                paginationRowsPerPageOptions={[10, 15, 25, 50]}
                customStyles={customStyles}
                noDataComponent={
                  <div className="text-center py-5">
                    <i className="ri-user-3-line fs-1 text-muted d-block mb-2" />
                    <p className="text-muted mb-0">Aucun élève dans cette classe</p>
                  </div>
                }
                paginationComponentOptions={{
                  rowsPerPageText: "Lignes par page",
                  rangeSeparatorText: "sur",
                }}
                highlightOnHover
                responsive
              />
            </Offcanvas.Body>
          </Offcanvas>
        </Container>
      </div>
    </React.Fragment>
  );
};
export default Classes;
